import type { DialogButtonTemplateParams } from 'Components/smallComponents/dialogButton';
import type { TemplateFunction, TemplateResult } from 'Components/types';

import VehicleWidget from '../../vehicleWidget/index';
import type { VehicleWidgetTemplateParams } from '../../vehicleWidget/vehicleWidget';
import AddButton from '../addButton';
import { vehicleWidgetName } from '../garage';

interface Props {
  template: TemplateFunction<EmptyDropdownTemplateParams>;
  closeGarage: () => void;
  doNotRedirectOnVehicleSelect?: boolean;
  isAutoVehicleSelectionDisabled: boolean;
  redirectUrl?: string;
  showVehicleDropdowns: () => void;
  useNativeDropdown?: boolean;
  useVehicleWidget?: boolean;
}

export interface EmptyDropdownTemplateParams {
  addButton: (templ: TemplateFunction<DialogButtonTemplateParams>) => TemplateResult;
  closeGarage: () => void;
  showVehicleDropdowns: () => void;
  vehicleWidget: (templ: TemplateFunction<VehicleWidgetTemplateParams>) => TemplateResult;
  template: 'empty';
}

export default function EmptyDropdown({
  template,
  closeGarage,
  doNotRedirectOnVehicleSelect,
  isAutoVehicleSelectionDisabled,
  redirectUrl,
  showVehicleDropdowns,
  useNativeDropdown,
  useVehicleWidget,
}: Props): TemplateResult {
  const addButton = (templ: TemplateFunction<DialogButtonTemplateParams>) => (
    <AddButton closeGarage={closeGarage} template={templ} key="add" />
  );

  const vehicleWidget = (templ: TemplateFunction<VehicleWidgetTemplateParams>) => {
    if (!useVehicleWidget) {
      return null;
    }

    const props = {
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled,
      name: vehicleWidgetName,
      doNotRedirectOnVehicleSelect,
      redirectUrl,
      useNativeDropdown,
      template: templ,
    };
    return <VehicleWidget {...props} key="VehicleWidget" />;
  };

  return template.call({ addButton, closeGarage, showVehicleDropdowns, vehicleWidget, template: 'empty' });
}
